import { render, staticRenderFns } from "./Churchportal.vue?vue&type=template&id=02718f71&"
import script from "./Churchportal.vue?vue&type=script&lang=js&"
export * from "./Churchportal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports